<template>
  <div v-if="isOpen" class="modal-backdrop">
    <div class="modal-container" @click.stop>
      <div class="modal-content">
        <div class="modal-title">{{ title }}</div>
        <div class="modal-message">
          <p>{{ message }}</p>
          <p>{{ addMessage }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="com_s_button1" @click="onClose">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from "vue";
import { useProcessingStore } from "../../store/useProcessingStore";

export default defineComponent({
  name: "EventApplyModalComponent",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    addMessage: {
      type: String,
    },
  },
  emits: ["closeModal"],
  setup(props, { emit }) {
    const processingStore = useProcessingStore();
    onUnmounted(() => {
      // 画面の縦スクロールを有効化
      document.body.classList.remove("modal-open");
    });

    /**
     * モーダルを閉じる
     */
    const onClose = () => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }
      emit("closeModal");
    };

    return {
      onClose,
    };
  },
});
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: white;
  padding: 70px;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 50%; /* モーダルの幅を設定 */
  height: 60%;
  padding-bottom: 35px;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
}

.modal-content {
  flex: 1; /* 残りのスペースを占める */
  border-width: 0px;
  margin: 0 auto; /* 中央寄せ */
  flex-direction: column;
  display: flex;
  overflow-y: auto; /* モーダル内でスクロールを有効にする */
  height: 60vh; /* モーダルの高さを設定 */
  padding: 5px;
  white-space: pre-line; /* 改行を反映 */
}

.modal-title {
  margin-top: 5%;
  margin-bottom: 5%;
  font-size: 1.6em; /* フォントサイズを大きくする */
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  white-space: pre-line; /* 改行を反映 */
}

.modal-message {
  padding-left: 15%;
  padding-right: 15%;
}

.modal-footer {
  background: none;
  border-top: 1px solid #999;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 1.8rem;
  padding-bottom: 0% !important;
}

.button-container {
  display: flex;
  justify-content: right; /* ボタンの間隔を広げる */
  width: 100%;
  padding: 0 20px; /* モーダルフォームの両側に余白を作成 */
  position: absolute;
  bottom: 20px; /* モーダルフォームの下辺からの距離 */
}

button {
  margin: 0 10px; /* 上下のマージンは0、左右のマージンを10pxに設定 */
  width: 150px;
  height: 40px;
  border-radius: 10px;
}

.com_s_button1 {
  font-size: 18px;
  width: 120px;
}

p {
  margin-top: 0%;
  margin-bottom: 0%;
}

.modal-open {
  overflow: hidden; /* ボディのスクロールを無効化 */
}
</style>
